import React, { useEffect, useState } from "react";
import {
  Container,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  Form,
  Label,
  Input,
} from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useMemo } from "react";
import { useTable, usePagination, useGlobalFilter } from "react-table";

import "../../../assets/css/Finance/Style/PerformaInvoice/performaInvoice.css";
import { Table, Row, Col, Card, CardBody, Modal } from "reactstrap";
import Pagination from "components/Common/Pagination";

// Hover card
import axios from "axios";
import Loader from "pages/Separate/Loader";
import configure from "configure";
import Swal from "sweetalert2";
import AccessDeniedPopup from "routes/AccessDeniedPopup";
import AddInvoice from "./AddInvoice";
import { fetchData, fetchNodeData, FetchNodePutData } from "utils/common-fetchData";
import secureLocalStorage from "react-secure-storage";
import EditInvoice from "./EditInvoice";
import { performaInvoice } from "utils/columns/Finance/financeColumns";
import { checkPermissionsByModule } from "utils/common-helpers";
import { useSelector } from "react-redux";
import { Draggable } from "devextreme-react";
import { ResizableBox } from "react-resizable";
import moment from "moment";
import { useSearchParams } from "react-router-dom";

function TableContainer({
  columns,
  data,
  setDatas,
  allData,
  setLoading,
  fetchInvoiceData,
  setAccessDenied,
  roles,
}) {
  const [fixedContent, setFixedContent] = useState(false);
  const [modal_fullscreen, setmodal_fullscreen] = useState(false);
  const [fromDateFilter, setFromDateFilter] = useState(false);
  const [toDateFilter, setToDateFilter] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [tab, setTab] = useState(0);
  const [activeFilter, setActiveFilter] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams();



  const initialSearch =
    searchParams.get("search") || "";

  const initialPage =
    Number(searchParams.get("page")) || 0;

  const initialPageSize =
    Number(searchParams.get("pageSize")) || 10;


  useEffect(() => {
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") setmodal_fullscreen(false);
    });

    document.addEventListener("scroll", () => {
      if (window.scrollY > 165) {
        setFixedContent(true);
      } else {
        setFixedContent(false);
      }
    });
  }, [])

  useEffect(() => {
    switch (tab) {
      case 0:
        setDatas(allData)
        break;
      case 1:
        setDatas(allData?.filter((d) => d.tax_inv_no))
        break;
      case 2:
        setDatas(allData?.filter((d) => !d.tax_inv_no))
        break;

      default:
        setDatas(allData)
    }
  }, [tab])

  // Use the state and functions returned from useTable to build your UI
  // const {
  //   getTableProps,
  //   getTableBodyProps,
  //   headerGroups,
  //   page,
  //   state,
  //   previousPage,
  //   nextPage,
  //   canPreviousPage,
  //   canNextPage,
  //   gotoPage,
  //   setPageSize,
  //   pageOptions,
  //   setGlobalFilter,
  //   prepareRow,
  // } = useTable(
  //   {
  //     columns,
  //     data,
  //   },
  //   useGlobalFilter,
  //   usePagination,
  // );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    pageOptions,
    canNextPage,
    gotoPage,
    setPageSize,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data,

      initialState: {
        pageIndex: initialPage,
        pageSize: initialPageSize,
        globalFilter: initialSearch,
      },
    },
    useGlobalFilter,
    usePagination,
  );

  const { pageIndex, pageSize, globalFilter } = state;

  useEffect(() => {

    setSearchParams({
      search: globalFilter || "",
      page: pageIndex,
      pageSize,
    });

  }, [globalFilter, pageIndex, pageSize]);

  useEffect(() => setPageSize(50), []);
  const [allOption, setAllOption] = useState({});
  const [filterPopup, setFilterPopup] = useState(false);
  const [boxWidth, setBoxWidth] = useState(0);
  const token = secureLocalStorage.getItem("auth_token");


  const onAddInvoice = async (location = 1) => {
    const permission = checkPermissionsByModule(roles, 44, 3);
    if (permission) {
      const res = await fetchNodeData(
        setLoading,
        `ztplPerformaIndex/get/${location}`,
        token,
      );
      if (res?.status == 200) {
        setmodal_fullscreen(true);
        setAllOption(res?.data);
      }
    } else {
      setAccessDenied(true);
    }
  };
  useEffect(() => {
    const updateWidth = () => {
      const viewportWidth = window.innerWidth;
      setBoxWidth(viewportWidth * 0.5);
    };
    updateWidth();
    const hash = location?.hash?.split("-");
    if (hash[0] == "#lead") {
      onAddInvoice();
    }
  }, []);

  const closeModal = (close, load) => {
    setmodal_fullscreen(false);
    if (load) {
      fetchInvoiceData();
    }
  };

  const handleFilter = (e) => {
    e.preventDefault();

    if (
      fromDateFilter &&
      toDateFilter &&
      moment(fromDateFilter).isAfter(moment(toDateFilter))
    ) {
      Swal.fire({
        icon: "warning",
        title: "Invalid date range",
        text: "End date must be after the start date.",
      });
      console.warn("⚠️ Invalid date range:", fromDateFilter, ">", toDateFilter);
      return;
    }

    if (fromDateFilter || toDateFilter) {
      try {
        let filteredData = data ?? [];

        // Apply From Date Filter
        if (fromDateFilter) {
          const passedIds = [];
          const failedIds = [];

          filteredData = filteredData.filter((item) => {
            const invoiceDate = moment(item.invoice_date).startOf("day");
            const fromDate = moment(fromDateFilter).startOf("day");
            const result = invoiceDate.isSameOrAfter(fromDate);

            if (result) passedIds.push(item.id);
            else failedIds.push(item.id);

            return result;
          });
        }

        // Apply To Date Filter
        if (toDateFilter) {
          const passedIds = [];
          const failedIds = [];

          filteredData = filteredData.filter((item) => {
            const invoiceDate = moment(item.invoice_date).startOf("day");
            const toDate = moment(toDateFilter).startOf("day");
            const result = invoiceDate.isSameOrBefore(toDate);

            if (result) passedIds.push(item.id);
            else failedIds.push(item.id);

            return result;
          });
        }

        setDatas([...filteredData]);
        setActiveFilter(true)
      } catch (error) {
        console.error("❌ Error during filtering:", error);
        Swal.fire({
          icon: "error",
          title: "Something went wrong",
          text: "Unable to apply filters. Please try again.",
        });
      }
    } else {
      Swal.fire({
        icon: "warning",
        text: "Please enter at least one filter criterion to proceed.",
      });
      console.warn("⚠️ No filter criteria entered");
    }
  };

  const handleClear = () => {
    setFromDateFilter("");
    setToDateFilter("");
    fetchInvoiceData();
    setActiveFilter(false)
  };

  const taxConvertedCount = useMemo(
    () => allData?.filter((d) => d.tax_inv_no)?.length,
    [allData],
  );


  const TABS = useMemo(() => ([
    {
      title: "Total Invoices",
      value: allData.length
    },
    {
      title: "Converted to tax",
      value: taxConvertedCount
    },
    {
      title: "Not Converted",
      value: allData.length - taxConvertedCount
    },
  ]), [taxConvertedCount, allData])

  return (
    <div>
      {/* fixed buttons */}
      <div
        className={`flex-column fixed-buttons pt-2 mt-3 ${fixedContent ? "d-flex" : "d-none"
          }`}
      >
        <Link
          onClick={() => onAddInvoice()}
          className="btn btn-save  fix-btn btn-label pe-0"
        >
          <i className="fas fa-plus me-2 icon-size label-icon"></i>
          <span>Invoice</span>
        </Link>
      </div>
      <Row className="m-0 d-flex justify-space-between align-items-center">
        <div className="p-0 col-md-6 d-flex gap-4">
          <div>
            <select
              className=" form-select "
              style={{ width: "100px" }}
              value={pageSize}
              onChange={(e) => setPageSize(e.target.value)}
            >
              {[10, 25, 50, 100].map((pageSize) => (
                <option key={pageSize} value={pageSize}>
                  Show {pageSize}
                </option>
              ))}
            </select>
          </div>

          <div className="d-flex gap-4 align-items-center">
            {
              TABS.map((item, i) => (
                <div key={item.title}
                  onClick={() => setTab(i)}
                  className={`general-box cursor-pointer px-2 ${tab === i ? 'bg-purple' : 'text-purple'} `}>
                  {item.title} - <b>{item.value}</b>
                </div>
              ))
            }
          </div>
        </div>
        <div className="p-0 col-md-6 gap-2 d-flex justify-content-end align-items-end">
          <button
            onClick={() => setFilterPopup(!filterPopup)}
            className={`btn ${activeFilter ? 'btn-success' : 'btn-outline-secondary'} me-3`}
          >
            <i className="fas fa-filter"></i> {activeFilter && 'Filter Applied!'}
          </button>

          <div className="search-box my-xxl-0 d-inline-block">
            <div className="position-relative">

              <label
                htmlFor="search-bar-0"
                className="search-label mb-0"
              >
                <span
                  id="search-bar-0-label"
                  className="sr-only"
                >
                  Search this table
                </span>

                <input
                  id="search-bar-0"
                  type="search"
                  className="form-control rounded h-100 pe-4"
                  placeholder="Search..."
                  value={globalFilter || ""}
                  onChange={(e) =>
                    setGlobalFilter(e.target.value)
                  }
                />
              </label>
              {
                globalFilter?.length &&
                <i className="fas fa-times search-icon"
                  onClick={() => setGlobalFilter("")}
                  style={{ left: 'auto', right: "10px" }}></i>
              }
              <i className="bx bx-search-alt search-icon"></i>
            </div>
          </div>

          <div>
            <button
              className=" btn btn-save btn-label"
              onClick={() => onAddInvoice()}
            >
              <i className="fas fa-plus me-2 label-icon"></i>
              Add PRF Invoice
            </button>
          </div>
        </div>
      </Row>

      <div className="position-relative" id="pis-ztpl">
        <Table className="table table-bordered mt-4" {...getTableProps()}>
          <thead
            className={`${fixedContent ? "fix-headers" : ""
              } fix-introducer-header`}
          >
            {headerGroups.map((headerGroup, i) => (
              <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <th
                    key={index}
                    className={`t-col-${index + 1} ${column.className}`}
                    {...column.getHeaderProps()}
                  >
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody className="fix-introducer-header" {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row);
              const converted =
                row?.original?.tax_inv_no != null &&
                row?.original?.approve == 1;
              return (
                <tr
                  className={`row-hover ${converted ? "bg-light-success" : ""}`}
                  {...row.getRowProps()}
                  key={i}
                >
                  {row.cells.map((cell, index) => {
                    return (
                      <td
                        key={index}
                        className={`t-col-${index + 1} ${cell.column.className
                          }`}
                        {...cell.getCellProps()}
                      >
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <Pagination
          gotoPage={gotoPage}
          previousPage={previousPage}
          canPreviousPage={canPreviousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
        />
      </Row>

      {/* ================== Add  Modal ================== */}
      <Modal size="xl" isOpen={modal_fullscreen} className="modal-fullscreen">
        <AddInvoice
          allOption={allOption}
          closeModal={closeModal}
          onAddInvoice={onAddInvoice}
        />
      </Modal>

      {filterPopup ? (
        <Draggable>
          <ResizableBox
            width={boxWidth}
            style={{
              position: "fixed",
              top: "30%",
              right: "3%",
              zIndex: "1055",
              backgroundColor: "#fff",
            }}
          >
            {/* <div className="expense-filter">
                <div className="popup-form p-4"> */}
            <Form
              onSubmit={handleFilter}
              className="row d-flex justify-content-center align-items-center"
            >
              <div className="col-md-12 d-flex ">
                <div className="col-md-3 ps-2">
                  <Label htmlFor="formrow-firstname-Input">From Date</Label>
                  <Input
                    type="date"
                    // required={toDateFilter ? true : false}
                    value={fromDateFilter}
                    onChange={(e) => setFromDateFilter(e.target.value)}
                  />
                </div>
                <div className="col-md-3 ps-2">
                  <Label htmlFor="formrow-firstname-Input">To Date</Label>
                  <Input
                    type="date"
                    value={toDateFilter}
                    onChange={(e) => setToDateFilter(e.target.value)}
                  />
                </div>

                <div className="col-md-6 d-flex justify-content-end align-items-center gap-2">
                  <button className="btn  btn-save btn-label me-1">
                    <i className="fas fa-filter search-icon label-icon"></i>{" "}
                    Filter
                  </button>
                  <a
                    className="btn  btn-danger"
                    style={{
                      fontSize: "14px",
                      backgroundColor: "#fed36d",
                      borderColor: "#fed36d",
                      color: "black",
                    }}
                    onClick={() => handleClear()}
                  >
                    Clear Filters
                  </a>

                  <a
                    className="btn btn-red btn-label me-1"
                    onClick={() => {
                      setFilterPopup(false);
                    }}
                  >
                    <i className="dripicons-cross label-icon"></i> Close
                  </a>
                </div>
              </div>
            </Form>
          </ResizableBox>
        </Draggable>
      ) : null}
    </div>
  );
}

const Ztpl = () => {
  const [modal_fullscreen, setmodal_fullscreen] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const roles = useSelector((state) => state?.Roles?.apiData);
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") setViewModal(false), setEditModal(false);
  });

  //meta title
  document.title = "ZTPL | Zithas Crm";

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") setmodal_fullscreen(false);
  });

  const [data, setDatas] = useState([]);
  const [allOption, setAllOption] = useState([]);
  const [allData, setAllData] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [view, setView] = useState(false);
  const [invoiceData, setInvoiceData] = useState({});

  const [modal_Access, setAccessDenied] = useState(false);
  const token = secureLocalStorage.getItem("auth_token");
  useEffect(() => {
    fetchInvoiceData();
  }, []);

  const fetchInvoiceData = async () => {
    const response = await fetchNodeData(
      setLoading,
      `ztplPerformaIndex/allInvoice`,
      token,
    );
    if (response?.status == 200) {
      const filtered = response?.data?.filter((i) =>
        configure.location.includes(i.location),
      );
      setDatas(filtered);
      setAllData(filtered);
    }
  };

  const onEditInvoice = async (obj, view) => {
    const permission = checkPermissionsByModule(roles, 44, 4);
    if (permission) {
      const res = await fetchNodeData(
        setLoading,
        `ztplPerformaIndex/get/${obj.location || 1}`,
        token,
      );
      if (res?.status == 200) {
        setAllOption(res?.data);
        setInvoiceData(obj);
        setEditModal(true);
        setView(view);
      }
    } else {
      setAccessDenied(true);
    }
  };

  const ondelete = (id) => {
    const permission = checkPermissionsByModule(roles, 44, 5);
    if (permission) {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you really want to delete this Invoice?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#762C99",
        cancelButtonColor: "#BF1E30",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            setLoading(true);
            const res = await axios.delete(
              `${configure.nodeApi}/ztplPerformaIndex/${localStorage.getItem(
                "auth_id",
              )}/${id}`,
            );
            setLoading(false);
            if (res?.data?.status == 200) {
              Swal.fire("Deleted!", "The Invoice has been deleted.", "success");
              fetchInvoiceData();
            }
          } catch (e) {
            Swal.fire("Error", "Something Went Wrong", "error");
          }
        }
      });
    } else {
      setAccessDenied(true);
    }
  };

  const isClone = async (id) => {
    const permission = checkPermissionsByModule(roles, 44, 3);
    if (permission) {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to clone this Invoice?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Clone it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const res = await fetchNodeData(
            setLoading,
            `ztplPerformaIndex/clone/${localStorage.getItem("auth_id")}/${id}`,
            token,
          );
          if (res?.status == 200) {
            Swal.fire("Success", "Invoice has been cloned", "success");
            fetchInvoiceData();
          }
        }
      });
    } else {
      setAccessDenied(true);
    }
  };

  const onConvertTax = async (id) => {
    const permission = checkPermissionsByModule(roles, 44, 4);
    if (permission) {
      Swal.fire({
        icon: "warning",
        title: "Are You Sure ?",
        text: "You Want to Convert Tax to Invoice?",
        showCancelButton: true,
        confirmButtonText: "Yes, convert it!",
        cancelButtonText: "No, cancel!",
      }).then(async (result) => {
        if (result?.isConfirmed) {
          const res = await fetchData(
            setLoading,
            `convert_invoice/${id}`,
            token,
          );
          if (res.success) {
            Swal.fire({
              icon: "success",
              title: "Invoice Converted Successfully",
            }).then(() => {
              fetchInvoiceData();
            });
          }
        }
      });
    } else {
      setAccessDenied(true);
    }
  };

  // table columns
  const columns = useMemo(
    () => performaInvoice(onEditInvoice, ondelete, isClone, onConvertTax),
    [],
  );
  const closeModal = (load) => {
    setEditModal(false);
    if (load) {
      fetchInvoiceData();
    }
  };

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={"Dashboard"}
            breadcrumbItem={"Zithas Technologies Private Limited"}
          />

          <Row>
            <Col lg={12} className="p-0">
              <Card>
                <CardBody>
                  <div className="responsive-table">
                    <TableContainer
                      columns={columns}
                      data={data}
                      setDatas={setDatas}
                      allData={allData}
                      setAllData={setAllData}
                      setAccessDenied={setAccessDenied}
                      setLoading={setLoading}
                      fetchInvoiceData={fetchInvoiceData}
                      roles={roles}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* ================== Edit  Modal ================== */}
      <Modal size="xl" isOpen={editModal} className="modal-fullscreen">
        <EditInvoice
          allOption={allOption}
          closeModal={closeModal}
          invoiceData={invoiceData}
          view={view}
          inv={false}
        />
      </Modal>

      <AccessDeniedPopup
        modal_Access={modal_Access}
        setAccessDenied={setAccessDenied}
      />
    </React.Fragment>
  );
};

export default Ztpl;
